import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(() => {
    const { isAuth, isEmailVerified, isProfileCompleted, isRejected } = storeToRefs(
        useAuthStore(),
  )

    const route = useRoute()

    if (isAuth.value) {
        console.log('User is authenticated', route)

    if (isEmailVerified.value) {
            if (!isProfileCompleted.value && isRejected.value) {
                return navigateTo('/complete-profile')
            }
            else {
                return navigateTo('/dashboard')
            }
        }
    }
})
